module.exports = __webpack_public_path__ + "img/arrow_down_icon.4ebf902e.svg";